<template>
  <div class="playlist">
    <div class="playlist__back">
      <div class="playlist__back__button" @click="onClickBack">
        <div class="playlist__back__button__icon">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_back.svg" />
        </div>
        <div>
          Volver
        </div>
      </div>
    </div>
    <div class="playlist__modes">
      <button class="playlist__modes__button" :class="{ disabled: !booleanIsFromMexico && !getIsGSUser }" @click="onClickOpenModes">
        <span class="desktop">Haz click aquí para elegir lo que deseas ver</span>
        <span class="mobile">Haz click aquí para elegir</span>
      </button>
    </div>
    <div v-show="false" class="playlist__title">{{ `${playlistTitle}${subject}` }}</div>
    <!--  playseeker  -->
    <template v-if="getCurrentPlayerQueue && getCurrentPlayerQueue.length && getCurrentPlayerQueue[0].isPlaySeeker">
      <div class="playlist__header-play-seeker">
        <div></div>
        <div class="play">Jugada</div>
        <div>PARTIDO</div>
        <div>FECHA</div>
      </div>
      <div class="playlist__play-seeker-plays">
        <div
          v-for="(objectPlay, index) of getCurrentPlayerQueue"
          :key="objectPlay.playId"
          class="playlist__play-seeker-plays__play"
          @click="onClickPlaySeekerPlay(objectPlay, index)"
        >
          <div class="play-icon">
            <img
              :src="
                `https://golstatsimages.blob.core.windows.net/todoelfut/icn_play_${index === playlistIndex ? 'green' : 'grey'}.svg`
              "
            />
          </div>
          <div class="play-time">12:30</div>
          <div class="play-info">{{ objectPlay.mainCategoryName }} - {{ objectPlay.playerShortName }}</div>
          <div class="play-game">
            <div class="play-game__team-logo">
              <img :src="objectPlay.homeTeamLogo" />
            </div>
            <div class="play-game__score">
              <span>{{ `${objectPlay.arrayScore[0]} - ${objectPlay.arrayScore[1]}` }}</span>
            </div>
            <div class="play-game__team-logo">
              <img :src="objectPlay.awayTeamLogo" />
            </div>
          </div>
          <div class="play-date">
            <span v-if="objectPlay.gameDate">{{ new Date(objectPlay.gameDate) | formattedDate('d/M/yyyy') }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="playlist__header">
        <div>partido</div>
        <div>marcador</div>
        <div>fecha</div>
      </div>
      <div class="playlist__games">
        <BCollapse
          v-for="(game, index) of currentPlayerQueueByGames"
          animation="slide"
          :id="`game-${index}`"
          :key="index"
          :open="currentGameIndex === index"
          :aria-id="'ariaId' + index"
          @open="onGameOpen(game, index)"
          @close="onGameClose(index)"
        >
          <template #trigger="props">
            <div
              class="playlist__games__game-header"
              :class="{ 'game-active': currentGameIndex === index }"
              role="button"
              :aria-controls="'ariaIdT' + index"
              :aria-expanded="props.open"
              @click="onGameHeaderClick(game, index)"
            >
              <div class="playlist__games__game-header__content">
                <div class="icon">
                  <img
                    v-if="game.booleanIsFullGame"
                    :src="
                      `https://golstatsimages.blob.core.windows.net/todoelfut/icn_play_${
                        index === playlistIndex ? 'green' : 'grey'
                      }.svg`
                    "
                  />
                  <img
                    v-else
                    :src="
                      `https://golstatsimages.blob.core.windows.net/todoelfut/icn_${
                        currentGameExpandedIndex === game.gameIndex ? 'colapsar' : 'desplegar'
                      }.svg`
                    "
                  />
                </div>
                <div class="teams">
                  <span>{{ windowWidth > 480 ? game.homeTeam.name : game.homeTeam.acronym }}</span>
                  <span class="vs"> VS </span>
                  <span>{{ windowWidth > 480 ? game.awayTeam.name : game.awayTeam.acronym }}</span>
                </div>
                <div class="score">{{ `( ${game.score[0]} - ${game.score[1]} )` }}</div>
                <div class="date">
                  {{
                    game.date
                      .split('-')
                      .reverse()
                      .join('/')
                  }}
                </div>
              </div>
            </div>
          </template>
          <div v-if="!game.booleanIsFullGame" class="playlist__games__game__plays">
            <div
              v-for="(play, index) of game.plays"
              :key="play.dateTimeMillis + index"
              class="playlist__games__game__plays__play"
              :class="{ active: play.index === playlistIndex }"
              @click="onPlayClick(play.index)"
            >
              <div class="play-icon">
                <img
                  :src="
                    `https://golstatsimages.blob.core.windows.net/todoelfut/icn_play_${
                      play.index === playlistIndex ? 'green' : 'grey'
                    }.svg`
                  "
                />
              </div>
              <div class="play-time-start">
                {{ getStartMinutes(play.momentOfPlay.split('.')[0]) }}
              </div>
              <div class="play-info">
                {{ `${getCategoryFormat(play.mainCategory.name)} - ${play.player.shortName}` }}
              </div>
              <div
                class="play-is-favorite"
                :class="{ disabled: !getIsGSUser && !getIsB2CPremium }"
                @click="openAddPlayList(play)"
                :style="{ cursor: play.isSaved || (!getIsGSUser && !getIsB2CPremium) ? 'default' : 'pointer' }"
              >
                <img :src="`https://golstatsimages.blob.core.windows.net/todoelfut/icn_${play.isSaved ? 'saved' : 'unsaved'}.svg`" />
              </div>
            </div>
          </div>
        </BCollapse>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'Playlist',
  components: {
    BCollapse: async () => {
      const { BCollapse } = await import('buefy/dist/esm/collapse');
      return BCollapse;
    },
  },
  props: {
    subject: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentGameIndex: 0,
      currentGameExpanded: null,
      currentGameExpandedIndex: -1,
      // playlistTitle: '',
    };
  },
  computed: {
    ...mapGetters('loginGeneral', ['getIsGSUser', 'getIsB2CPremium']),
    ...mapState(['windowWidth']),
    ...mapState('loginGeneral', ['booleanIsFromMexico']),
    ...mapState('mediaModal', ['modalInitialState', 'playlistIndex', 'advancedFilter']),
    ...mapGetters('mediaModal', ['currentPlayerQueueByGames', 'getCurrentPlayerQueue', 'getModalSectionSelected']),
    playlistTitle() {
      // const mainSections = ['Goles', 'Jugadas Relevantes'];
      // return this.modalInitialState.advancedFilter && this.modalInitialState.advancedFilter.playListTitle
      //   ? this.modalInitialState.advancedFilter.playListTitle
      //   : '';
      return '';
    },
  },
  watch: {
    currentPlayerQueueByGames(newValue) {
      if (newValue && newValue.length) {
        this.currentGameExpanded = newValue[0];
        this.currentGameExpandedIndex = 0;
      } else {
        this.currentGameExpanded = null;
      }
    },
    playlistIndex: {
      immediate: true,
      handler(newValue) {
        let gameIndex = 0;
        const game = this.currentPlayerQueueByGames.find((game, index) => {
          gameIndex = index;
          return newValue >= game.initialPlayIndex && newValue <= game.finalPlayIndex;
        });
        if (game) {
          let collapseElement = null;
          if (this.currentGameExpanded && this.currentGameExpanded.id !== game.id) {
            this.currentPlayerQueueByGames.forEach(listGame => {
              listGame.isExpanded = false;
            });
          }
          this.currentGameIndex = gameIndex;
          this.currentGameExpanded = game;
          this.currentGameExpandedIndex = game.gameIndex;

          setTimeout(() => {
            collapseElement = document.getElementById(`game-${gameIndex}`);
            if (collapseElement) {
              collapseElement.scrollIntoView(true);
            }
          }, 300);
        }
      },
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setPlaylistIndex', 'setIsModalCreatePlayListOpen']),
    ...mapMutations('mediaGeneral', ['setPlaysToSaveAsFavorites']),
    // todo: verify time with values over 100
    onClickOpenModes() {
      if (this.booleanIsFromMexico || this.getIsGSUser) {
        this.$emit('click-open-modes');
      }
    },
    openAddPlayList(play) {
      if (play.isSaved || (!this.getIsGSUser && !this.getIsB2CPremium)) {
        return;
      }
      this.setPlaysToSaveAsFavorites([play.playRaw]);
      this.setIsModalCreatePlayListOpen(true);
    },
    getStartMinutes(minutesString = '000:00') {
      if (minutesString.startsWith('0')) {
        return minutesString.slice(1);
      }
      return minutesString;
    },
    getGeneralName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word, index) => {
          if (index === 0) {
            if (word.includes('.')) {
              accumulator.push(word);
            } else {
              const wordAux = word.toLowerCase().split('');
              wordAux[0] = wordAux && wordAux[0] ? wordAux[0].toUpperCase() : '';
              accumulator.push(wordAux.join(''));
            }
          } else {
            accumulator.push(word.toLowerCase());
          }
          return accumulator;
        }, [])
        .join(' ');
    },
    getSingleName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word) => {
          let wordAux = word;
          if (word.endsWith('minaron')) {
            wordAux = word.replace('minaron', 'minó');
          } else if (word.endsWith('vocan')) {
            wordAux = word.replace('vocan', 'voca');
          } else if (word.endsWith('lones')) {
            wordAux = word.replace('lones', 'lón');
          } else if (word.endsWith('oles')) {
            wordAux = word.replace('oles', 'ol');
          } else if (word.endsWith('os') || word.endsWith('as') || word.endsWith('es')) {
            wordAux = word.slice(0, word.length - 1);
          }
          accumulator.push(wordAux);
          return accumulator;
        }, [])
        .join(' ');
    },
    getCategoryFormat(categoryName = '') {
      const generalName = this.getGeneralName(categoryName);
      return this.getSingleName(generalName);
    },
    onClickPlaySeekerPlay(objectPlay, numberIndex) {
      if (this.currentGameIndex !== numberIndex) {
        this.currentGameIndex = numberIndex;
        this.setPlaylistIndex({ mediaPlayerType: null, playlistIndex: numberIndex });
      }
    },
    onGameHeaderClick(objectGame, numberIndex) {
      if (objectGame.booleanIsFullGame && this.currentGameIndex !== numberIndex) {
        this.currentGameIndex = numberIndex;
        this.currentGameExpanded = objectGame;
        this.currentGameExpandedIndex = objectGame.gameIndex;
        this.setPlaylistIndex({ mediaPlayerType: null, playlistIndex: numberIndex });
      }
    },
    onGameOpen(game, index) {
      this.currentGameIndex = index;
      this.currentGameExpanded = game;
      this.currentGameExpandedIndex = game.gameIndex;
    },
    onGameClose() {
      this.currentGameExpanded = null;
      this.currentGameExpandedIndex = -1;
    },
    onClickBack() {
      this.$emit('back');
    },
    onPlayClick(playIndex) {
      if (playIndex !== this.playlistIndex) {
        this.setPlaylistIndex({ mediaPlayerType: null, playlistIndex: playIndex });
      }
    },
  },
};
</script>

<style scoped lang="scss">
$blue: #132839;
$green: #cbee6b;

.playlist {
  font-size: 1rem;
  width: 100%;
  height: 100%;
  max-height: 738px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0.5em 1em 1em;
  border-radius: 13px;
  border: solid 2px #e4eef4;
  font-family: Avenir-Demi, sans-serif;

  &__back {
    padding-bottom: 1em;
    border-bottom: 1px dashed #d1e0ea;
    margin-bottom: 0.5em;

    &__button {
      display: flex;
      justify-content: center;
      width: fit-content;
      padding: 0.2em 1em 0;
      border-radius: 20px;
      border: solid 1px #000;
      font-family: Roboto-Regular, sans-serif;
      font-size: 0.9375em;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.47;
      letter-spacing: -0.15px;
      cursor: pointer;

      &__icon {
        margin-right: 0.5em;
      }
    }
  }

  &__modes {
    padding-bottom: 0.5em;
    border-bottom: 1px dashed #d1e0ea;
    margin-bottom: 0.5em;

    &__button {
      font-family: Avenir-Demi, sans-serif;
      font-size: 1.18753em;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.95;
      letter-spacing: -0.38px;
      text-align: center;
      color: #132839;
      border-radius: 40px;
      background-color: #f8f040;
      border: solid 2px #f8f040;
      padding: 0.75em 1.57895em 0.55em;
      cursor: pointer;

      & > span {
        &.mobile {
          display: none;
        }
      }

      @media screen and (max-width: 600px) {
        & span {
          &.desktop {
            display: none;
          }
          &.mobile {
            display: inline;
          }
        }
      }
    }
  }

  &__advanced-search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px dotted #c1d2dc;
    padding-bottom: 0.5em;

    &__text {
      font-size: 1.1875em;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.95;
      letter-spacing: -0.38px;
      text-align: left;
      color: $blue;
    }

    &__button {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 7px;
      background-color: $green;
      padding: 0.5em 1em;
      cursor: pointer;

      & > div {
        &:first-child {
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.13;
          letter-spacing: -0.32px;
          color: $blue;
          white-space: nowrap;
        }
      }
    }
  }

  &__title {
    width: 100%;
    font-size: 1.625em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.85;
    letter-spacing: -0.52px;
    text-align: left;
    color: $blue;
    padding: 0.6em 0;
  }

  &__header {
    display: grid;
    grid-template-columns: 51% min-content 1fr;
    padding: 0.6em 0 0.3em;
    border-radius: 6px;
    background-color: $blue;
    text-transform: uppercase;
    font-size: 0.6875em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: 0.44px;
    text-align: center;
    color: #bbd0e1;

    & > div {
      justify-self: flex-start;

      &:first-child {
        padding-left: 20%;
      }

      &:last-child {
        padding-left: 15%;
      }
    }
  }

  &__header-play-seeker {
    display: grid;
    grid-template-columns: 22% 30% 30% 1fr;
    padding: 0.6em 0 0.3em;
    border-radius: 6px;
    background-color: $blue;
    font-size: 0.6875em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: 0.44px;
    text-align: center;
    color: #bbd0e1;

    & > div {
      justify-self: center;

      &.play {
        width: 100%;
        text-align: left;
      }
    }
  }

  &__play-seeker-plays {
    width: 100%;
    overflow: auto;
    font-family: Avenir-Demi-Medium, sans-serif;

    &__play {
      padding: 0.5em 0 0;
      display: grid;
      grid-template-columns: 10% 10% 40% 16% 1fr;
      border-bottom: dashed 1px #d1e0ea;
      cursor: pointer;

      & > div {
        justify-self: center;
        align-self: center;
        font-size: 0.875em;

        &.play-info {
          padding-left: 1em;
          width: 100%;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &.play-game {
          margin-top: -0.3em;
          display: flex;
          justify-content: center;
          align-items: center;
          white-space: nowrap;

          & > div {
            margin: 0 0.1em;
          }

          & .play-game__team-logo {
            height: 18px;
            width: 18px;

            & > img {
              height: 18px;
              width: 18px;
            }
          }

          & .play-game__score {
            margin-top: 0.25em;
          }
        }
      }
    }
  }

  &__games {
    margin-top: 0.5em;
    max-height: 55vh;
    overflow: auto;

    &__game-header {
      border-radius: 6px;
      border: solid 1px #dbe5ee;
      background-color: #f4f6f9;
      margin: 0.2em;

      &.game-active {
        padding: 0.1em;
        background-color: white;

        & .playlist__games__game-header__content {
          border-radius: 6px;
          background-color: #e4fca5;
        }
      }

      &__content {
        display: grid;
        grid-template-columns: 11% 40% 5.5em 1fr;
        font-size: 0.875em;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: -0.28px;
        text-align: left;
        padding: 0.8em 0 0.6em;

        & > div {
          align-self: center;

          &.icon {
            padding-left: 0;
            width: 100%;
            justify-self: flex-start;

            & img {
              height: 24px;
              width: 24px;
            }
          }

          &.teams {
            text-transform: uppercase;
            & > span.vs {
              font-size: 0.85em;
              font-weight: 500;
            }
          }

          &.score {
            white-space: nowrap;
            justify-self: center;
          }

          &.date {
            margin-left: 1.2em;
          }
        }
      }
    }

    &__game {
      &__plays {
        padding: 0 0.2em;
        &__play {
          display: grid;
          grid-template-columns: min-content min-content 1fr min-content;
          font-family: Avenir-Demi-Medium, sans-serif;
          font-size: 0.875em;
          padding: 0.6153em 0;
          cursor: pointer;

          &:nth-child(1n + 1) {
            border-top: 1px dashed #d1e0ea;
          }

          & > div {
            justify-self: left;
          }

          & .play-icon {
            height: 20px;
            width: 20px;
            margin: 0 25px;
            & img {
              height: 20px;
              width: 20px;
            }
          }

          & .play-time-start {
            margin: 0 1em 0 0;
          }

          & .play-info {
            text-align: left;
          }

          & .play-is-favorite {
            height: 20px;
            width: 20px;
            margin: 0 1em;
            & img {
              height: 20px;
              width: 20px;
            }
          }

          &.active {
            color: #7caa0a;
          }
        }
      }
    }
  }

  @media screen and (min-width: 600px) {
    &__back {
      display: none;
    }

    &__games {
      max-height: 680px;
    }
  }

  @media screen and (max-width: 480px) {
    padding: 1em 0.1em;

    &__back {
      margin-left: 0.5em;
    }

    &__title {
      width: 100%;
      text-align: center;
    }

    &__header {
      grid-template-columns: 42% min-content 1fr;
    }

    &__games {
      &__game-header {
        &__content {
          grid-template-columns: 11% 30% 5.5em 1fr;
          & > div {
            font-size: 0.9285em;

            &.icon {
              padding-left: 0;
              width: 100%;
              justify-self: flex-start;

              & img {
                height: 24px;
                width: 24px;
              }
            }

            &.teams {
              & > span.vs {
                font-size: 0.85em;
                font-weight: 500;
              }
            }

            &.date {
              margin-left: 1em;
            }
          }
        }
      }

      &__game {
        &__plays {
          &__play {
            display: grid;
            grid-template-columns: min-content min-content 1fr min-content;

            & .play-icon {
              margin: 0 5px;
            }
          }
        }
      }
    }
  }
}

.disabled {
  cursor: default;
  opacity: 0.6;
}
</style>
